import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ControlList, Dialog, useListGraphqlQuery, useTranslationRoute, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useCallback } from "react";
import _ from "lodash";
import { useScholarityQuery } from "../../details/hooks/useScholarityQuery";
import { SCHOLARITY_LIST_ID } from "../../../container/ScholarityListContainer";
import { useScholarityCreateForm } from "../hooks/useScholarityCreateForm";
import { STUDENT_LIST_ID } from "views/list/containers/StudentListContainer";
import { useCreateScholarityMutation } from "../../details/hooks/useCreateScholarityMutation";
import { useClassMenuItems } from "views/list/hooks/useClassMenuItems";

export const ScholarityCreateContainer = () => {
    const urlParams = useUrlParamsValueToString()
    const { scholarityId } = useParams()
    const tr = useTranslationRoute()
    const path = useLocation().pathname
    const navigate = useNavigate()
    const control = useScholarityCreateForm(scholarityId ? parseInt(scholarityId) : undefined)
    const { invalidateQuery } = useListGraphqlQuery(SCHOLARITY_LIST_ID);
    const { data, invalidateQuery: invalidateDetailsQuery } = useScholarityQuery(scholarityId ? parseInt(scholarityId) : undefined)
    const { invalidateQuery: invalidateStudentListQuery } = useListGraphqlQuery(STUDENT_LIST_ID);
    const mutation = useCreateScholarityMutation()
    const classes = useClassMenuItems();

    const isEdit = !_.isEmpty(scholarityId)

    const handleSubmited = useCallback(() => {
        invalidateDetailsQuery()
        invalidateStudentListQuery()
        invalidateQuery()
        if(isEdit) {
            navigate(tr(`admin/students/viewer/scholarity/${scholarityId}?${urlParams}`))
            return
        }
        navigate(`..?${urlParams}`)
    }, [invalidateQuery])

    const handleClose = useCallback(() => {
        navigate(tr(`admin/students/viewer/scholarity?${urlParams}`))
    }, [])

    const handleSubmit = useCallback((value) => {
        mutation.mutate(
            { value },
            {
                onSuccess: () => {
                    handleSubmited()
                },
            }
        )
    }, [])


    return (
        <Dialog open title={!isEdit ? "Create scholarity" : "Edit scholarity"} onClose={handleClose}>
            <ControlList
                {...control}
                defaultValue={{
                    id: parseInt(scholarityId),
                    ...(_.omit(data, 'scholarityClass')),
                    scholarityClass: classes?.find((c) => c.value === data?.scholarityClass?.class?.value)
                }}
                onSubmit={handleSubmit}
                onCancel={handleClose}
            />
        </Dialog>
    );
}